<div class="wrapper" cpClickOut (clickOut)="showCalendar=false" [ngClass]="{'navigation-mode-only': navigationModeOnly}">
	<span #dateLabel><i *ngIf="!navigationModeOnly" (click)="this.showCalendar=!this.showCalendar" class="cp-icon-date_picker"></i></span>
	<i (click)="previous()" class="cp-sh-icon-arrow_previous" cpHotkeys [codes]="'Date.Prev'" (hotKeysPress)="previous()"></i>
	<i (click)="next()" class="cp-sh-icon-arrow_next" cpHotkeys [codes]="'Date.Next'" (hotKeysPress)="next()"></i>

	<div (click)="this.showCalendar=!this.showCalendar">
		<ng-content> </ng-content>
	</div>

	<span (click)="!navigationModeOnly && (this.showCalendar=!this.showCalendar)" class="date-label" [ngClass]="{'non-default-date': isNonDefaultDate()} ">
		<ng-container [ngSwitch]="dateMode">
			<ng-container *ngSwitchCase="'default'">
				<span>{{date|cpDate:"Full":true:false}}</span>
				<span class='day-name'>({{date|cpDayName}})</span>
			</ng-container>
			<ng-container *ngSwitchDefault>{{formattedDateRange}}</ng-container>
		</ng-container>
	</span>


	<ng-container *ngIf="showCalendar">
		<kendo-popup [popupAlign]="popupDir" [anchor]="dateLabel" [animate]="useAnimation" class="custom-calendar-container">
			<cp-calendar
				[date]="date"
				[showNavigationArrows]="true"
				[markerFunction]="dateMode !== 'default' ? markerFunction : null"
				[dateMode]="dateMode"
				(dateChange)="dateSelected($event)">
			</cp-calendar>
		</kendo-popup>
	</ng-container>
</div>
